<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="successDialog" v-model="successDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header success pa-0 text-center">
						<div class="text-right pa-1">
							<!--<v-icon @click="close" size="20" color="#d9d6ee">{{ icons.mdiClose }}</v-icon>-->
						</div>
						<h4 class="fs--24 fw--600 popup-header-text mt-2">Success!</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<template v-if="sticker.stickerType === 'TTS'">
								<AssetsTTS :sticker="sticker" :list="false" :popupMd="true" />
							</template>
							<template v-else>
								<v-img :src="getStickerImagePath(sticker)" width="100%" contain height="100"></v-img>
							</template>
							<p class="fw--600 fs--13 white--text mt-3">
								You slapped a {{ sticker.name }} sticker for 0 Bits
							</p>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { computed, watch } from 'vue';
import { useStore } from '@/store';
import { getStickerImagePath } from '@/utils/utils';
import { mdiClose } from '@mdi/js';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';

export default {
	components: {
		AssetsTTS
	},
	props: {
		successDialog: {
			type: Boolean,
			default: false,
		},
		sticker: Object,
	},
	emits: ['onClose'],
	setup(props, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const close = () => {
			ctx.emit('onClose');
		};

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		};

		// Close automatically after display.
		watch(props, value => {
			if (value.successDialog) {
				setTimeout(() => {
					close();
				}, 5000);
			}
		});

		return {
			theme,
			size,
			close,
			cancelEvent,
			getStickerImagePath,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>

<style scoped>
.popup-header-text {
	padding-top: 15px !important;
}
</style>
